import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import Process from './imgs/process.gif';
import axios from 'axios';
import PropTypes from 'prop-types';
import { debug } from 'util';
import hmg from './imgs/h1.jpeg';
import Configdata from './Defaultdata';
import './home.css';
import { getmessage,reducearray,arrprtojson,toggleitm,sortarray,sortarraydsc,filterpostedby,setuserpoints,arrpa,clsmsg,amini } from './Dynamictable';
import Usersession from './Usersession';
import {getaminities} from './Viewaminities';


export default class Search extends Component {
   constructor(props: any){
   	super(props);
	this.state.name = "siikaa";
	//this.testfnc = this.testfnc.bind(this);
   }	
    state = {
	strimg:"",
        name: "World",
        type: "1",
        Phone: null,
        msg: "",
        typeoption: null,
        expoption: null,
        catoption: null,
        bindopt: null,
        isVisible: true,
        resm: null,
        url: "",
        animid:'an-',
        toglesort:false,
        tpb: null,
        opening: [{}],
	properties: [{id:0,code:'sp000',price: '00'}],
	selectedpros: [{
code:"A001", userid:"", typeid:"", transtype:"", isowner:"", cityid:"", localityid:"", title:"", description:"", conditions:"", area:"", totalfloors:"",floorno:"", propertyage:"", postedby:"", ownership:"", aiminities:"", curtntstatus:"", phone:"", price:"", availablefrom:"",
 delflag:"", procontryid:"", aiminityvalues:"",age:"",lname:""
}],
searchedpros: [{
code:"A001", userid:"", typeid:"", transtype:"", isowner:"", cityid:"", localityid:"", title:"", description:"", conditions:"", area:"", totalfloors:"",floorno:"", propertyage:"", postedby:"", ownership:"", aiminities:"", curtntstatus:"", phone:"", price:"", availablefrom:"",
 delflag:"", procontryid:"", aiminityvalues:"",age:"",lname:""
}]
    };
 
  testfnc(){
   //  alert('test');
	
  };

   
   
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
       // debugger;
    // this.testfnc();
      //  this.testsort();
        this.setserverurl();
     	//  alert('reach');
        this.getdata();
	this.showclosesort(0);
	//this.sopencloseproc(false);
    }
 testsort(){
 const arr = [
 {id:1,nm:"A",price:"2.0",area:20},
{id:2,nm:"B",price:"1.0",area:10},
{id:1,nm:"C",price:"3.0",area:50},
{id:1,nm:"E",price:"2.5",area:5},
 ];
const srt = sortarraydsc(arr,"area");
//alert(JSON.stringify(srt));
} 
filteredpros(data: any,postedby: any){
if(data){
if(postedby){

 const fltdata = filterpostedby(data,postedby);
 //this.setState({selectedpros: fltdata});
 this.setState({selectedpros: data});
	
}
else{
this.setState({selectedpros: data});
}
}

}
sortareaincrease(e: any){
 if(this.state.selectedpros.length > 0){
 const srt = sortarray(this.state.selectedpros,"area");
 this.setState({selectedpros: srt}); 
 this.showclosesort(0);
 this.setState({ toglesort: false });
}
e.preventDefault()
};  
sortareadesrease(e: any){
if(this.state.selectedpros.length > 0){
const srt = sortarraydsc(this.state.selectedpros,"area");
this.setState({selectedpros: srt});
this.showclosesort(0);
this.setState({ toglesort: false });
}
e.preventDefault()
};  
sortpriceincrease(e: any){
if(this.state.selectedpros.length > 0){
const srt = sortarray(this.state.selectedpros,"price");
this.setState({selectedpros: srt});
this.showclosesort(0);
this.setState({ toglesort: false });
}
e.preventDefault()
};
sortpricedesrease(e: any){
if(this.state.selectedpros.length > 0){
const srt = sortarraydsc(this.state.selectedpros,"price");
this.setState({selectedpros: srt});
this.showclosesort(0);
this.setState({ toglesort: false });
}
e.preventDefault()
};  
sopencloseproc(opt: any){
		
		
		const prciconedv = document.getElementById('sprocessicon') as HTMLElement;
		if(opt){
		
		prciconedv.style.display = 'block';
		}
		else{
		
		prciconedv.style.display = 'none';

		}

	};


getdata(){
	 try {
	// alert('in func ');
	
	getmessage('Please wait searching.......','');
	const searchopts = Usersession.getSearchopts();
	const ptype = Usersession.getType();
        const localityd = searchopts.localid;
        const transctpid = searchopts.trnstpid;
	
	const cityid = searchopts.ctid;
	const postedid = searchopts.postedby;
	// 1 is owner
	//2 is member

	//alert(postedid);
        let service = "/gethomeposts?prd=1&ctd="+cityid+"&ltd="+localityd+"&tpd="+transctpid;
        if(ptype == "2")
	 service ="/getlandposts?prd=1&ctd="+cityid+"&ltd="+localityd+"&tpd="+transctpid;
       //alert(service);	
	axios.get(Configdata.srvurl + service)
            .then((response: any) => {
              // alert(response.data);
		const tdata = response.data;
		//alert(tdata);
		const proarrdata = arrpa(tdata);
		//alert(proarrdata.length);
		this.setState({searchedpros:proarrdata});
		this.filteredpros(proarrdata,postedid);
                clsmsg();
		
            })
            .catch((err: any) => {
              //  getmessage('Something went wrong','');
		//this.sopencloseproc(false);
                
            });

                
          }
        catch (e) {
            //debugger;
		//this.sopencloseproc(false);
        }

	
      	//e.preventDefault()


     }	
 setpropertyephoto(code: any){
	 try {
            
            const pid = code;
            
	        const response = axios.post(Configdata.srvurl + '/getproperyimg', {
    		pcode: pid
		
    		
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const strphoto = result.data;
		if(strphoto.length > 10){
		
		this.setState({ strimg: strphoto });
		this.showclosephoto(1);
	
		}
		else{
		getmessage('Photo not available','');
		}
		
		
	        });		
              }
		
    	 }
     	 catch (e) {
           // debugger;

	 }

  }

 showimage(e: any){
	const eid = e.target.id;
	this.setpropertyephoto(eid);
	
	e.preventDefault();
 } 
 showclosephoto(opt: any){
  const Pdivc = document.getElementById('prohotodiv') as HTMLElement;	
  if(Pdivc){	
     if(opt == 1){
 	Pdivc.style.display = 'block';
     }
     else{
	Pdivc.style.display = 'none';
	}	
  }
}  
closephoto(e: any){
  this.showclosephoto(0);
  e.preventDefault();	
}
showclosesort(opt: any){
  const Pdivc = document.getElementById('sortitems') as HTMLElement;	
  if(Pdivc){	
     if(opt == 1){
 	Pdivc.style.display = 'block';
     }
     else{
	Pdivc.style.display = 'none';
	}	
  }
}  

togglesort(e: any){
const sdiv = document.getElementById('sortitems') as HTMLElement;
const opt = toggleitm(this.state.toglesort);
if(sdiv){
	

	if(opt){
 	  sdiv.style.display='block';
	}else
	{
	  sdiv.style.display='none';
	}
	this.setState({ toglesort: opt });

 }
 e.preventDefault();	

}
filters(e: any){

getmessage('Should be Bronch member or above','')
 e.preventDefault();	

}
viewcontact(e: any){
const cod = e.target.id;
const upin = localStorage.getItem("id");
//alert(cod);
this.viewphone(upin,cod);
getmessage('Each view charges 30 points','If less than 50 points Please check offers');
 e.preventDefault();	

}
viewaminities(e: any){
const cod = e.target.id;
const amndiv = document.getElementById(cod) as HTMLElement;
const htmltxt = amndiv.innerHTML;
const amintxt = htmltxt.replace('Aminities<span style=','').replace('display: none;','').replace('</span>','').replace('>','').replace('""','');
//alert(amintxt);
let arramn = amintxt.split(',');
let railway = '';
let busstop ='';
let hospitsl ='';
let school ='';
if(arramn[0]) railway = arramn[0];
if(arramn[1]) busstop = arramn[1];
if(arramn[2]) hospitsl = arramn[2];
if(arramn[3]) school = arramn[3];

amini(railway,busstop,hospitsl,school);
//getmessage(amintxt,'')
 e.preventDefault();	

}

viewphone(pin: any,code: any){

 try {
            
            const pid = code;
            
	        const response = axios.post(Configdata.srvurl + '/getprophone', {
    		upcode: code,
		upin:pin
		
    		
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		let strphone = result.data;
		if(strphone){
		const cd = 'Property Code: ' + code;
		if(strphone == 'NA'){
			 strphone = 'Unavailable';
		}else{
		const ph = 'Contact No : ' + strphone.split(':')[0];
                const pnts = strphone.split(':')[1];
		setuserpoints(pnts);
		getmessage(cd,ph);	
		}	
		}
		else{
		getmessage('Contact not available','');
		}
		
		
	        });		
              }
		
    	 }
     	 catch (e) {
           // debugger;

	 }

  

}
 render() {

   
     return (

         <div id="searchmain">
	<div className="searchcointer" style={{maxHeight:'94vh',overflowY:'scroll',overflowX:'hidden'}}>
	<div className="shortbartop">
	   <div style={{width:'50%',float:'left'}}>

	   </div>
	   <div style={{width:'49%',float:'right',marginRight:'1%'}}>
		<div className="sortbar-item">
		  <a href="#" onClick={e=>this.togglesort(e)} className="notxtdecorate">
	          <div className="sortbar-item-s">S</div>
		  </a>		
		</div>
		<div className="sortbar-item">
		 <a href="#" onClick={e=>this.filters(e)} className="notxtdecorate">
	         <div className="triangle-down"></div>	
		 </a>	
		</div>
	   </div>	
		
	</div>
	<ul className="ulnobullet" style={{padding:'0px'}}>
          {this.state.selectedpros.map((property)=>(
	   <li>
 	    <div className="searchdivrow">
		<div className="searchouterdiv">
		   <div style={{width:'100%',height:'28%'}}>
		      <div className="per100">
			<div className="searchphotodiv">
			  <div style={{width:'100%',height:'100px'}}>
			    <a href="#" onClick={e=>this.showimage(e)} >
			     <img src={hmg} id={property.code} className="searchitemphoto" />
			    </a>	

			  </div>
			 <div style={{width:'100%',height:'20px'}}>
				<a href="#" id={property.code} onClick={e=>this.viewcontact(e)} >View Contact</a>
			 </div>
			 <div style={{width:'100%',height:'20px'}}>
	<a href="#"  onClick={e=>this.viewaminities(e)} ><span id={'AN-' + property.code}>Aminities<span style={{display:'none'}}>{property.aiminityvalues}</span></span></a>
			 </div>
		       </div>
			
			<div className="searchpiddiv">
			  <ul className="ulnobullet">
					  <li> {property.title}</li>
				          <li> At  {property.lname}  </li>	
						 	
					</ul>

		 	 </div>

			</div>
		     </div>

		   <div style={{width:'100%',height:'45%'}}>
		<div className="per100">
		 	
		


		 	<div className="searchcontaintdiv">
   			 <table className="per100">
			     <tr>
				<td>
				   <div>
					<ul className="ulnobullet">
					  <li> Price</li>
				          <li> {property.price}L </li>		
					</ul>
				   </div>
				</td>
				<td>
				   <div>
					<ul className="ulnobullet">
					  <li> Area</li>
				          <li> {property.area} sft {property.age} BHK </li>		
					</ul>
				   </div>

				</td>

			     </tr>

			     <tr>
				<td>
				  <div>
				     <ul className="ulnobullet">
					  <li> Availablility</li>
				          <li> {property.availablefrom}</li>		
				    </ul>
				 </div>
				</td>
				<td>
				   <div>
				     <ul  className="ulnobullet">
					  <li> Posted By</li>
				          <li> {property.postedby}</li>		
				    </ul>
				 </div>

				</td>

			     </tr>




			      <tr>
				<td>
				     <div>
				     <ul className="ulnobullet">
					  <li> Condition</li>
				          <li> {property.conditions}</li>		
				    </ul>
				 </div>
				</td>
				<td>
				    <div>
				     <ul className="ulnobullet">
					  <li> Property Age</li>
				          <li> {property.propertyage}</li>		
				    </ul>
				 </div>
				</td>

			     </tr>

			     <tr>
				<td>
				     <div>
				     <ul className="ulnobullet">
					  <li> Floors</li>
				          <li> {property.totalfloors} / {property.floorno}</li>		
				    </ul>
				 </div>
				</td>
				<td>
				    <div>
				     <ul className="ulnobullet">
					  <li> Ownership</li>
				          <li> {property.ownership}</li>		
				    </ul>
				 </div>
				</td>

			     </tr>



			  </table>

	  		</div>
		 </div>
		</div>

	 <div style={{width:'100%',height:'34%'}}>
		<div className="per100">	
			<div style={{width:'100%',height:'20px',paddingLeft:'10px',float:'left'}}>	
			  Description:
			</div>
			<div className="descriptioncontain">	
			 
				{property.description} .
				Grab the property and enjoy with your family which is sournding by many educational institutes.the property
is easy access to trantsport and near by health cares . 

				

			</div>

		</div>
	     </div>	
	    
	       </div>
	     </div>

	    </li>
	
       	   ))}
	</ul>
	</div>
   <div id="sortitems" className='sort-items'>
       <ul className="ulnobullet" style={{padding:'0px',marginBlock:'0px'}}>
	
	  <li className="sort-item-li"><a href="#" onClick={e=>this.sortpriceincrease(e)} className="notxtdecorate">Increase Price</a></li>
	   <li className="sort-item-li"><a href="#" onClick={e=>this.sortpricedesrease(e)} className="notxtdecorate"> Decrease Price</a></li>
	  <li  className="sort-item-li"><a href="#" onClick={e=>this.sortareaincrease(e)} className="notxtdecorate"> Increase Area</a></li>
	   <li className="sort-item-li"><a href="#" onClick={e=>this.sortareadesrease(e)} className="notxtdecorate"> Decrease Area</a></li>		
		
	</ul>
   </div>
    <div id= "prohotodiv"  className='property-photoshow'>
		<div className="search-title-bar">
                       	<div className="search-title">
			  Property Image
			</div>
			<a href="#" onClick={e=>this.closephoto(e)} title="Property image">
			<div className="search-title-toggle" id="togglesearch">
			  X
			</div>
			</a>
	   	     </div>
		<div id = "imgfromstrpro" className="per100">
			<img src={this.state.strimg} id="propertyphoto" style={{width:'100%',height:'85vh'}} />
		</div>	
     </div>
 		<div id="sprocessicon" style={{width:'50px',height:'50px',marginTop:'0px',position:'fixed',left:'50vw',top:'50vh',display:'none'}}>
			
		</div>

</div>

);

      
}
}

